/* nische probe-guard: mix codes PROBEN5 do not block the set */
function initNischeReadMore() {
  document.querySelectorAll('[data-nische-read-more], [data-nische-description]').forEach((container) => {
    if (container.dataset.readMoreInitialized === 'true') return;

    const content = container.querySelector('[data-description-content]');
    const toggle = container.querySelector('[data-description-toggle]');
    const labelMore = container.querySelector('[data-description-label-more]');
    const labelLess = container.querySelector('[data-description-label-less]');

    if (!content || !toggle || !labelMore || !labelLess) return;

    const collapsedLines = Math.max(1, parseInt(container.dataset.collapsedLines || '2', 10));
    const collapsedHeight = parseFloat(getComputedStyle(content).lineHeight || '0') * collapsedLines;

    if (content.scrollHeight <= collapsedHeight + 1) {
      toggle.hidden = true;
      container.dataset.readMoreInitialized = 'true';
      return;
    }

    content.classList.add('is-collapsed');

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      content.classList.toggle('is-collapsed', isExpanded);
      content.classList.toggle('is-expanded', !isExpanded);
      labelMore.hidden = !isExpanded;
      labelLess.hidden = isExpanded;
    });

    container.dataset.readMoreInitialized = 'true';
  });
}

function scrollNavToSelected(nav, item) {
  const selected = item || nav.querySelector('[aria-current="page"]') || nav.querySelector('.is-selected');
  if (!selected) return;

  const maxScrollLeft = nav.scrollWidth - nav.clientWidth;
  if (maxScrollLeft <= 0) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = prefersReducedMotion ? 'auto' : 'smooth';
  const targetScrollLeft = selected.offsetLeft - nav.clientWidth / 2 + selected.offsetWidth / 2;

  nav.scrollTo({
    left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
    behavior,
  });
}

function scheduleNavScroll(nav, item) {
  if (!nav) return;

  const run = () => scrollNavToSelected(nav, item);

  requestAnimationFrame(() => {
    run();
    setTimeout(run, 50);
    setTimeout(run, 200);
    setTimeout(run, 400);
    setTimeout(run, 800);
  });
}

function getActiveVendorFilterValues() {
  const facetForm = document.querySelector('#facet-form[is="facet-form"], form.facets-vertical[is="facet-form"]');
  let activeVendors = [];

  if (facetForm) {
    activeVendors = Array.from(
      facetForm.querySelectorAll('input[type="checkbox"][name="filter.p.vendor"]:checked')
    ).map((input) => input.value);
  }

  if (!activeVendors.length) {
    activeVendors = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
  }

  return activeVendors;
}

function syncCollectionFilterRowWithVendorFilter() {
  const filterRow = document.querySelector('.nische-collection-filter-row__list');
  if (!filterRow) return;

  const facetForm = document.querySelector('#facet-form[is="facet-form"], form.facets-vertical[is="facet-form"]');
  const hasVendorCheckboxes = !!facetForm?.querySelector('input[type="checkbox"][name="filter.p.vendor"]');
  const activeVendors = getActiveVendorFilterValues();
  const items = filterRow.querySelectorAll('.nische-collection-filter-row__item');
  let selectedItem = null;

  if (!activeVendors.length && !hasVendorCheckboxes) return;

  items.forEach((item) => {
    const isAllProducts = item.dataset.allProducts === 'true';
    let isMatch = false;

    if (activeVendors.length) {
      isMatch = !isAllProducts && item.dataset.vendorName === activeVendors[0];
    } else {
      isMatch = isAllProducts;
    }

    item.classList.toggle('is-selected', isMatch);

    if (isMatch) {
      item.setAttribute('aria-current', 'page');
      selectedItem = item;
    } else {
      item.removeAttribute('aria-current');
    }
  });

  if (selectedItem) {
    scheduleNavScroll(filterRow, selectedItem);
  }
}

function bindCollectionFilterVendorSync() {
  const facetForms = document.querySelectorAll('#facet-form[is="facet-form"], form.facets-vertical[is="facet-form"]');

  facetForms.forEach((form) => {
    if (form.dataset.nischeVendorFilterSyncBound === 'true') return;

    form.dataset.nischeVendorFilterSyncBound = 'true';

    form.addEventListener('change', (event) => {
      if (event.target?.name !== 'filter.p.vendor') return;
      syncCollectionFilterRowWithVendorFilter();
    });
  });

  syncCollectionFilterRowWithVendorFilter();
}

function bindCollectionFilterControls(nav) {
  if (nav.dataset.nischeCollectionFilterControlsBound === 'true') return;

  nav.dataset.nischeCollectionFilterControlsBound = 'true';

  const threshold = 125;
  let allowNearingStart = false;
  let allowLeavingStart = true;
  let allowNearingEnd = true;
  let allowLeavingEnd = false;
  let lastScrollPosition = Math.abs(nav.scrollLeft);

  const updateScrollable = () => {
    nav.classList.toggle('is-scrollable', nav.scrollWidth > nav.clientWidth + 1);
  };

  const getScrollAmount = () => {
    const gap = parseFloat(getComputedStyle(nav).columnGap || getComputedStyle(nav).gap) || 0;
    const firstItem = nav.querySelector('.nische-collection-filter-row__item');
    return (firstItem?.offsetWidth || 120) + gap;
  };

  const onScroll = () => {
    if (nav.scrollWidth <= nav.clientWidth) return;

    const direction = lastScrollPosition > Math.abs(nav.scrollLeft) ? 'start' : 'end';
    lastScrollPosition = Math.abs(nav.scrollLeft);

    const scrollPosition = Math.round(Math.abs(nav.scrollLeft));
    const scrollMinusSize = Math.round(nav.scrollWidth - nav.clientWidth);

    if (direction === 'start' && allowNearingStart && scrollPosition <= threshold) {
      allowNearingStart = false;
      allowLeavingStart = true;
      nav.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'start' } }));
    } else if (direction === 'end' && scrollPosition > threshold) {
      allowNearingStart = true;
      if (allowLeavingStart) {
        allowLeavingStart = false;
        nav.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'start' } }));
      }
    }

    if (direction === 'end' && allowNearingEnd && scrollMinusSize <= scrollPosition + threshold) {
      allowNearingEnd = false;
      allowLeavingEnd = true;
      nav.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'end' } }));
    } else if (direction === 'start' && scrollMinusSize > scrollPosition + threshold) {
      allowNearingEnd = true;
      if (allowLeavingEnd) {
        allowLeavingEnd = false;
        nav.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'end' } }));
      }
    }
  };

  updateScrollable();

  if (window.ResizeObserver) {
    new ResizeObserver(updateScrollable).observe(nav);
  }

  window.addEventListener('resize', updateScrollable);
  nav.addEventListener('scroll', onScroll, { passive: true });

  nav.addEventListener('control:prev', () => {
    nav.scrollBy({
      left: (document.dir === 'rtl' ? 1 : -1) * getScrollAmount(),
      behavior: 'smooth',
    });
  });

  nav.addEventListener('control:next', () => {
    nav.scrollBy({
      left: (document.dir === 'rtl' ? -1 : 1) * getScrollAmount(),
      behavior: 'smooth',
    });
  });

  nav.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'start' } }));
  onScroll();
}

function initCollectionFilterControls() {
  document.querySelectorAll('[data-nische-collection-filter-controls]').forEach(bindCollectionFilterControls);
}

function bindScrollNav(nav) {
  if (nav.dataset.nischeScrollNavBound === 'true') return;

  nav.dataset.nischeScrollNavBound = 'true';
  scheduleNavScroll(nav);

  nav.addEventListener('click', (event) => {
    const item = event.target.closest('a');

    if (!item || !nav.contains(item)) return;

    scheduleNavScroll(nav, item);
  });

  const accordion = nav.closest('details');

  if (accordion) {
    accordion.addEventListener('toggle', () => {
      if (accordion.open) {
        scheduleNavScroll(nav);
      }
    });
  }
}

function initNischeScrollNavs() {
  document.querySelectorAll('[data-nische-scroll-nav], [data-nische-category-nav]').forEach(bindScrollNav);
  initCollectionFilterControls();
}

function initNischeScrollNavEvents() {
  if (window.__nischeScrollNavEventsBound) return;

  window.__nischeScrollNavEventsBound = true;

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-nische-scroll-nav], [data-nische-category-nav]').forEach((nav) => {
      scheduleNavScroll(nav);
    });
    initCollectionFilterControls();
  });

  document.addEventListener('dialog:after-show', (event) => {
    const drawer = event.target;

    if (!drawer || drawer.id !== 'facets-drawer') return;

    drawer.querySelectorAll('[data-nische-scroll-nav], [data-nische-category-nav]').forEach((nav) => {
      bindScrollNav(nav);
      scheduleNavScroll(nav);
    });
  });
}

function initNischeCollectionFilters() {
  const facetForm = document.querySelector('#facet-form[is="facet-form"], form.facets-vertical[is="facet-form"]');
  if (!facetForm) return;

  const params = new URLSearchParams(window.location.search);
  const filterParams = [
    'filter.p.vendor',
    'filter.p.tag',
    'filter.p.m.custom.duftprofil',
    'filter.p.m.custom.groessen',
  ];

  filterParams.forEach((paramName) => {
    const activeValues = params.getAll(paramName);
    if (!activeValues.length) return;

    facetForm.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(paramName)}"]`).forEach((input) => {
      if (activeValues.includes(input.value)) {
        input.checked = true;
      }
    });
  });

  bindCollectionFilterVendorSync();
}

function initHeaderSearchBar() {
  const headerSearchBar = document.querySelector('.header__search-bar');
  const headerSearchInput = document.getElementById('header-search-input');
  const searchDrawer = document.getElementById('search-drawer');

  if (!headerSearchBar || !headerSearchInput || !searchDrawer || headerSearchBar.dataset.nischeSearchBound === 'true') return;

  headerSearchBar.dataset.nischeSearchBound = 'true';

  const openSearchDrawer = async () => {
    if (searchDrawer.open) return;

    await searchDrawer.show();

    const drawerInput = searchDrawer.querySelector('input[name="q"]');
    if (!drawerInput) return;

    if (headerSearchInput.value) {
      drawerInput.value = headerSearchInput.value;
      drawerInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    drawerInput.focus();
  };

  headerSearchInput.addEventListener('click', openSearchDrawer);

  headerSearchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openSearchDrawer();
    }
  });

  searchDrawer.addEventListener('dialog:after-hide', () => {
    headerSearchInput.value = '';
    headerSearchInput.blur();
  });
}

function parseTimeToMinutes(value) {
  if (!value || typeof value !== 'string') return null;

  const [hours, minutes] = value.split(':').map((part) => Number.parseInt(part, 10));
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

  return hours * 60 + minutes;
}

function getStoreDateParts(timezone) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(new Date());
  const weekday = parts.find((part) => part.type === 'weekday')?.value || '';
  const hour = Number.parseInt(parts.find((part) => part.type === 'hour')?.value || '0', 10);
  const minute = Number.parseInt(parts.find((part) => part.type === 'minute')?.value || '0', 10);
  const weekdayMap = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  return {
    dayIndex: weekdayMap[weekday] ?? new Date().getDay(),
    minutes: hour * 60 + minute,
  };
}

function initNischeOpeningHours() {
  const dataScript = document.querySelector('[data-nische-opening-hours]');
  const statusElement = document.querySelector('[data-nische-opening-status]');
  const statusText = document.querySelector('[data-nische-opening-status-text]');

  if (!dataScript || !statusElement || !statusText) return;

  let hoursData = {};

  try {
    hoursData = JSON.parse(dataScript.textContent);
  } catch (error) {
    console.error('Failed to parse opening hours data:', error);
    return;
  }

  const { dayIndex, minutes } = getStoreDateParts(hoursData.timezone || 'Europe/Berlin');
  const todaySchedule = hoursData.schedule?.[String(dayIndex)];
  const openMinutes = parseTimeToMinutes(todaySchedule?.open);
  const closeMinutes = parseTimeToMinutes(todaySchedule?.close);
  const isOpen = openMinutes !== null && closeMinutes !== null && minutes >= openMinutes && minutes < closeMinutes;

  statusElement.hidden = false;
  statusElement.classList.toggle('is-open', isOpen);
  statusElement.classList.toggle('is-closed', !isOpen);
  statusText.textContent = isOpen ? hoursData.openLabel : hoursData.closedLabel;
}

function initNischeProductPage() {
  initNischeReadMore();
  initNischeCollectionFilters();
  initNischeScrollNavEvents();
  initNischeScrollNavs();
  initHeaderSearchBar();
  initNischeOpeningHours();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNischeProductPage, { once: true });
} else {
  initNischeProductPage();
}

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNischeProductPage, 100);
});

document.addEventListener('facet:update', () => {
  setTimeout(() => {
    initNischeCollectionFilters();
    initNischeScrollNavs();
    initCollectionFilterControls();
    syncCollectionFilterRowWithVendorFilter();
  }, 100);
});

document.addEventListener('product:rerender', () => {
  setTimeout(initNischeProductPage, 100);
});

function nischeIsProbeText(...parts) {
  return parts.some((part) => String(part || '').toLowerCase().includes('probe'));
}

function nischeIsFollowupCredit(value) {
  const normalized = String(value || '').toUpperCase();
  return normalized.startsWith('PROBE45') || normalized.includes('FOLLOW-UP') || normalized.includes('FOLLOW UP');
}

function nischeCartHasFollowupCredit(cart) {
  const codes = (cart.discount_codes || []).map((item) => String(item.code || '').toUpperCase());
  const titles = (cart.cart_level_discount_applications || []).map((item) => String(item.title || '').toUpperCase());
  return [...codes, ...titles].some(nischeIsFollowupCredit);
}

function nischeItemIsProbe(item) {
  if (!item) return false;
  if (item.properties && item.properties._ProbeSet === 'true') return true;
  const optionValues = (item.options_with_values || []).map((option) => option.value);
  return nischeIsProbeText(item.variant_title, item.product_title, ...optionValues);
}

function nischeCartHasProbeSet(cart) {
  return (cart.items || []).some((item) => item.properties && item.properties._ProbeSet === 'true');
}

function nischeBlocksAdditionalProbes(cart) {
  return nischeCartHasFollowupCredit(cart) || nischeCartHasProbeSet(cart);
}

function nischeExtraSetMessage(cart) {
  if (nischeCartHasFollowupCredit(cart)) {
    return 'Mit dem 45-€-Gutschein kannst du nur einen Full-Size-Duft bestellen, kein weiteres Proben-Set.';
  }
  return 'Du hast schon ein Proben-Set im Warenkorb.';
}

function nischeCartHasVariant(cart, variantId) {
  return (cart.items || []).some((item) => String(item.variant_id) === String(variantId) && nischeItemIsProbe(item));
}

function nischeCartHasProduct(cart, productId) {
  if (!productId) return false;
  return (cart.items || []).some((item) => String(item.product_id) === String(productId) && nischeItemIsProbe(item));
}

function nischeVariantMarkedProbe(variantId) {
  const input = document.querySelector(`product-form input[name="id"][value="${variantId}"]`);
  if (input?.dataset.nischeProbe === 'true') return true;
  const selectedOption = document.querySelector('.product-info [aria-selected="true"], .product-info input:checked + label, .product-info .variant-picker');
  return nischeIsProbeText(selectedOption?.textContent);
}

window.NischeProbenCart = {
  blocksAdditionalProbes: nischeBlocksAdditionalProbes,
  extraSetMessage: nischeExtraSetMessage,
  cartHasVariant: nischeCartHasVariant,
  cartHasProduct: nischeCartHasProduct,
  messages: {
    noExtraSet: 'Mit dem 45-€-Gutschein kannst du nur einen Full-Size-Duft bestellen, kein weiteres Proben-Set.',
    alreadyHasSet: 'Du hast schon ein Proben-Set im Warenkorb.',
    duplicateScent: 'Jeder Duft kann nur einmal als Probe in den Warenkorb.',
    noExtraProbe: 'Weitere Proben sind mit dem 45-€-Gutschein nicht möglich. Bitte wähle einen Full-Size-Duft.',
  },
};

function nischeJsonResponse(status, payload) {
  return new Response(JSON.stringify(payload), {
    status,
    headers: { 'Content-Type': 'application/json' },
  });
}

async function nischeReadRequestBody(init) {
  const input = init?.body;
  if (!input) return {};
  if (typeof input === 'string') {
    try {
      return JSON.parse(input);
    } catch {
      return {};
    }
  }
  if (input instanceof FormData) {
    const data = {};
    input.forEach((value, key) => {
      data[key] = value;
    });
    return data;
  }
  if (typeof input === 'object') return input;
  return {};
}

function nischeIsMixCode(value) {
  return String(value || '').toUpperCase().startsWith('PROBEN5');
}

function nischeProbeSetCount(cart) {
  return (cart.items || []).filter((item) => item.properties && item.properties._ProbeSet === 'true').length;
}

function nischeCartDiscountCodes(cart) {
  return (cart.discount_codes || [])
    .map((item) => String(item?.code || '').trim())
    .filter(Boolean);
}

async function nischeStripMixCodesIfSetBroken(cart, nativeFetch, sectionPayload = {}) {
  const codes = nischeCartDiscountCodes(cart);
  if (!codes.some(nischeIsMixCode)) return cart;
  if (nischeProbeSetCount(cart) >= 5) return cart;

  const remaining = codes.filter((code) => !nischeIsMixCode(code));
  const body = { discount: remaining.join(',') };
  if (sectionPayload.sections) body.sections = sectionPayload.sections;
  if (sectionPayload.sections_url) body.sections_url = sectionPayload.sections_url;

  const response = await nativeFetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) return cart;
  try {
    return await response.json();
  } catch {
    return cart;
  }
}

function nischeExtractAddItems(payload) {
  if (Array.isArray(payload.items)) {
    return payload.items.map((item) => ({
      id: item.id,
      quantity: Number(item.quantity || 1),
      properties: item.properties || {},
    }));
  }
  if (payload.id) {
    const properties = {};
    Object.keys(payload).forEach((key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = payload[key];
    });
    return [{
      id: payload.id,
      quantity: Number(payload.quantity || 1),
      properties: payload.properties || properties,
    }];
  }
  return [];
}

function nischeInitProbeCartGuard() {
  if (window.__nischeProbeCartGuardBound) return;
  window.__nischeProbeCartGuardBound = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async function nischeGuardedFetch(resource, init = {}) {
    const url = String(resource?.url || resource || '');
    const method = String(init.method || 'GET').toUpperCase();
    const isCartWrite = method === 'POST' && /\/cart\/(add|change|update)\.js/.test(url);

    if (!isCartWrite) {
      return nativeFetch(resource, init);
    }

    const payload = await nischeReadRequestBody(init);
    const cart = await (await nativeFetch(`${window.Shopify.routes.root}cart.js`)).json();

    if (url.includes('/cart/add.js')) {
      const items = nischeExtractAddItems(payload);
      const addingProbeSet = items.some((item) => item.properties && item.properties._ProbeSet === 'true');
      const addingProbes = items.filter((item) => (
        (item.properties && item.properties._ProbeSet === 'true') ||
        nischeVariantMarkedProbe(item.id)
      ));

      if (addingProbeSet && nischeBlocksAdditionalProbes(cart)) {
        return nischeJsonResponse(422, { description: nischeExtraSetMessage(cart) });
      }

      if (addingProbes.length && nischeBlocksAdditionalProbes(cart) && !addingProbeSet) {
        const extraProbeMessage = nischeCartHasFollowupCredit(cart)
          ? window.NischeProbenCart.messages.noExtraProbe
          : 'Weitere Proben sind mit dem Set nicht möglich. Bitte wähle einen Full-Size-Duft.';
        return nischeJsonResponse(422, { description: extraProbeMessage });
      }

      const seen = new Set();
      for (const item of addingProbes) {
        if (Number(item.quantity || 1) > 1) {
          return nischeJsonResponse(422, { description: window.NischeProbenCart.messages.duplicateScent });
        }
        if (seen.has(String(item.id)) || nischeCartHasVariant(cart, item.id)) {
          return nischeJsonResponse(422, { description: window.NischeProbenCart.messages.duplicateScent });
        }
        seen.add(String(item.id));
      }
    }

    if (url.includes('/cart/change.js') || url.includes('/cart/update.js')) {
      const lineKey = payload.id || payload.line;
      const nextQuantity = payload.quantity == null ? null : Number(payload.quantity);
      if (lineKey && nextQuantity > 1) {
        const line = (cart.items || []).find((item) => (
          item.key === lineKey || String(item.variant_id) === String(lineKey)
        ));
        if (line && nischeItemIsProbe(line)) {
          return nischeJsonResponse(422, { description: window.NischeProbenCart.messages.duplicateScent });
        }
      }

      if (payload.updates && typeof payload.updates === 'object') {
        for (const [key, quantity] of Object.entries(payload.updates)) {
          if (Number(quantity) <= 1) continue;
          const line = (cart.items || []).find((item) => (
            item.key === key || String(item.variant_id) === String(key)
          ));
          if (line && nischeItemIsProbe(line)) {
            return nischeJsonResponse(422, { description: window.NischeProbenCart.messages.duplicateScent });
          }
        }
      }
    }

    const response = await nativeFetch(resource, init);
    if (!response.ok || !/\/cart\/(change|update)\.js/.test(url)) {
      return response;
    }

    try {
      const nextCart = await response.json();
      if (!nextCart || !Array.isArray(nextCart.items)) {
        return nischeJsonResponse(response.status, nextCart);
      }
      const strippedCart = await nischeStripMixCodesIfSetBroken(nextCart, nativeFetch, payload);
      return nischeJsonResponse(200, strippedCart);
    } catch {
      return response;
    }
  };
}

function nischeSyncVariantProbeState(event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  const form = event.target;
  const idInput = form?.querySelector?.('input[name="id"]');
  if (idInput) {
    idInput.dataset.nischeProbe = String(nischeIsProbeText(variant.title, variant.option1, variant.option2, variant.option3));
  }

  const quantityInput = form?.querySelector?.('input[name="quantity"]');
  if (quantityInput && nischeIsProbeText(variant.title, variant.option1, variant.option2, variant.option3)) {
    quantityInput.max = '1';
    if (Number(quantityInput.value) > 1) quantityInput.value = '1';
  }
}

document.addEventListener('variant:change', nischeSyncVariantProbeState);

nischeInitProbeCartGuard();
